import { createLaravelPassportClient } from '@skillbox/passport-client'

declare module '#app' {
  interface NuxtApp {
    $passportClient: ReturnType<typeof createLaravelPassportClient>;
  }
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const { $sentry } = useNuxtApp()

  let passportClient = null

  try {
    passportClient = createLaravelPassportClient({
      domain: config.public.passportDomain,
      client_id: config.public.passportClientId,
      redirect_uri: config.public.passportRedirectUri,
      scope: 'openid email profile roles permissions',
    })
  } catch (error) {
    $sentry.captureException(error)
  }

  return {
    provide: {
      passportClient,
    },
  }
})
